import React from "react";
import { Navigate } from "react-router-dom";
import { Container, Spinner, Alert } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";

// Route guard for /affiliate-dashboard. Reads role data from AuthContext —
// no DB queries here, so it never hangs.
const RequireAffiliate = ({ children }) => {
  const { user, profile, affiliate, loading } = useAuth();

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <Spinner animation="border" role="status" variant="success" />
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!affiliate) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <div style={{ maxWidth: "500px", textAlign: "center" }}>
          <Alert variant="warning">
            <b>No affiliate account found for this email.</b>
            <br />
            Make sure you're signing in with the same email you used on your
            application. If you haven't applied yet,{" "}
            <a href="/affiliate-request">apply here</a>.
          </Alert>
        </div>
      </Container>
    );
  }

  if (!profile?.onboarded) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <div style={{ maxWidth: "500px", textAlign: "center" }}>
          <Alert variant="info">
            <b>Please complete your onboarding in the Sarv app first.</b>
            <br />
            Download the app, finish the onboarding flow, and then come back
            here to access your affiliate dashboard.
          </Alert>
        </div>
      </Container>
    );
  }

  // Inject the affiliate row so the dashboard doesn't need to refetch.
  return React.cloneElement(children, { affiliate });
};

export default RequireAffiliate;
